module.exports = __webpack_public_path__ + "static/media/generic-ps.2b83d571.jpeg";